export const implementationTypes = {
  civilReports: { id: 'Civil Implementation', name: 'Civil Review', SR: true, implementation: true },
  systemReports: { id: 'installation', name: 'System Implementation Review', SR: true, implementation: true },
  siteAcceptance: { id: 'installation', name: 'Site Acceptance', SR: true, implementation: true },
  civilInstallation: { id: 'Civil Installation', name: 'Civil Installation', SR: true, implementation: true },
  PerformMaintenance: { id: 'PerformMaintenance', name: 'Perform Maintenance', SR: true, implementation: true },
  SystemInstallandConfiguration: { id: 'SystemInstallandConfiguration', name: 'System Install and Configuration', SR: true, implementation: true },
  SystemInstallandAccept: { id: 'SystemInstallandAccept', name: 'System Install and Accept', SR: true, implementation: true },
};
